/**
 * UI控件库 
 * @module UI
 */

;(function (ui,$) {
    
    /**
     * <h3>搜索条</h3>
     * <a href="../../ui_controls/bui.searchbar.html" target="_blank">demo</a>
     * <p></p>
     * {{#crossLink "bui.searchbar/option"}}{{/crossLink}}: 获取设置参数 <br>
     * {{#crossLink "bui.searchbar/widget"}}{{/crossLink}}: 获取依赖控件 <br>
     *  @namespace bui
     *  @class searchbar
     *  @constructor 
     *  @param {object} option  
     *  @param {string} option.id [控件id]  
     *  @param {string} [option.handle] [点击的搜索按钮]  
     *  @param {function} [option.onInput] [ 实时搜索的回调 ]  
     *  @param {function} [option.onRemove] [ 移除关键词以后的回调 ]  
     *  @param {function} [option.callback] [ 点击按钮的回调 ]  
     *  @example
     * 
     *   html:
     *
            <div id="searchbar" class="bui-searchbar">
                <div class="bui-input">
                    <i class="icon-search"></i>
                    <input type="text" value="" placeholder="搜索"/>
                </div>
            </div>
     *      
     *   js: 
     *   
            // 初始化
            var uiSearchbar = bui.searchbar({ 
                id: "#searchbar",
                callback: function(module,keyword) {
                    // 点击以后做什么事情
                }
              });
      
            
     *
     */
    ui.searchbar = function(option){

        var config = {
            id: "",        
            handle: ".icon-search",
            handleRemove: ".icon-remove",
            onInput: null,
            onRemove: null,
            callback: null
        }
        //方法
        var module = {
            search: search,
            widget: widget,
            option: options,
            config: param,
            init: init
        };
        //用于option方法的设置参数
        var param = module.config = $.extend(true, {},config, ui.config.searchbar, option );

        var $id,
            id,
            el,
            $handle,
            $input,
            $remove,
            $target;
        
        //执行初始化
        init(param);
        
        //初始化
        function init (option) {
            option = option || param;
            
            //验证id
            $id = ui.obj( option.id );

            //option获取新参数使用
            param = module.config = option;

            $handle = $id.find( option.handle );
            $input = $id.find("input");

            //增加删除按钮
            $id.find(option.handleRemove).length > 0 ? $remove : $id.find(".bui-input").append('<i class="'+option.handleRemove.substr(1)+'"></i>');
            $remove = $id.find(option.handleRemove);
            $remove.hide();

            //绑定事件
            bind(option);

            return this;
        }

        function bind(option) {
            //绑定搜索
            $id.off("click.bui",option.handle).on("click.bui",option.handle,function (argument) {
                
                var keyword = $input.val();

                option.callback && option.callback.call(this,module,keyword);
                
            })

            //绑定删除
            $id.off("click.bui",option.handleRemove).on("click.bui",option.handleRemove,function () {
                
                    $input.val('');

                var keyword = $input.val();

                    $(this).hide();
                option.onRemove && option.onRemove.call(this,module,keyword);

            })

            //监测搜索框有没有内容
            $id.off("input","input").on("input","input",function () {
                var keyword = $input.val();
                if( keyword ){
                    $remove.show();
                }else{
                    $remove.hide();
                }

                option.onInput && option.onInput.call(this,module,keyword);
            });

            return this;
        }
        
        /**
         * 调用搜索的方法
         *  @method search
         *  @param {string} [name] [ 依赖控件名 ]
         *  @example 
            
            uiSearchbar.search();
                
         */
        function search() {
            if( $handle.length ){
                $handle.trigger("click");
            }else{
                ui.hint("It can not find handle");
            }



            return this;
        }
        
        /**
         * 获取依赖的控件
         *  @method widget
         *  @param {string} [name] [ 依赖控件名 ]
         *  @example 
            
            //获取依赖控件
            var uiSearchbarWidget = uiSearchbar.widget();
            
                
         */
        function widget(name) {
            var control = {};
                return ui.widget.call(control,name);
        };
        /**
         * 获取设置参数
         *  @method option
         *  @param { string | object } [key] [ 不传则获取所有参数, 类型为string,没有第2个参数则获取某个参数 ]
         *  @param { string | number | boolean | function } [value] [ 设置参数的时候要传,设置多个参数不用传,获取参数的时候也不用传 ]
         *  @chainable
         *  @example 
            
            
            //获取所有参数
            var option = uiSearchbar.option();

            //获取某个参数
            var id = uiSearchbar.option( "id" );

            //修改一个参数
            uiSearchbar.option( "handle",".btn-search" );

            //修改多个参数
            uiSearchbar.option( {"handle":".btn-search"} );
                
         */
        function options (key,value) {

           return ui.option.call(module,key,value);
        }

        
        return module;
    };


    return ui;

})( bui || {}, libs );
